import React from 'react'
import styles from './Education.module.css';
import Title from '../helper/Title';



export default function BasicCard() {
  return (
    <section className={styles.section} id="education">
    <Title className={styles.sectiontitle} title='my' subTitle='education'/>
    <div className={styles.sectionone}>
            <h3>Gendarmerie and Coast Guard Academy</h3>
            <span className={styles.date}>2012 - 2014</span>
            <h4>Gendarmerie Petty Officer</h4>
            <p>
            Associate Degree
            </p>
    </div>
    <div className={styles.sectionone}>
            <h3>Eskisehir Anadolu University</h3>
            <span className={styles.date}>2014 - 2016</span>
            <h4>Faculty of Economics – Public Administration</h4>
            <p>
            Undergraduate
            </p>
    </div>
    <div className={styles.sectionone}>
            <h3>Eskisehir Anadolu University</h3>
            <span className={styles.date}>2017 - 2020</span>
            <h4>Open Education Faculty - Justice</h4>
            <p>
            Associate Degree
            </p>
    </div>
    <div className={styles.sectionone}>
            <h3>Ahmet Yesevi University</h3>
            <span className={styles.date}>2020 - 2021</span>
            <h4>Faculty of Engineering – Cyber Security</h4>
            <p>
            MA-High License
            </p>
    </div>
    <div className={styles.sectionone}>
            <h3>Neos Software and Academy</h3>
            <span className={styles.date}>2022 - 2023</span>
            <h4>Full Stack Web Developer</h4>
            <ul>
              <li>Training : Issued By NEOS AKADEMİ; Having Partipicated In The SOFTWARE SPECIALIST TRAINING 432 HOURS Program AndHaving Successfully Completed.</li>
              <br />
              <li>Internship : After training as a full stack web developer at Neos Software and Academy, I did an internship for 2 months.</li>
            </ul>
    </div>
    </section>

   
  );
}
